import { z } from 'zod';
import { ErrorCode, ErrorHttpStatusMap } from './codes.js';
export const ErrorDetailSchema = z.record(z.unknown()).optional();
export const ErrorEnvelopeSchema = z.object({
    error: z.object({
        code: z.nativeEnum(ErrorCode),
        message: z.string(),
        details: z.record(z.unknown()).optional(),
    }),
    requestId: z.string(),
});
export class AppError extends Error {
    code;
    status;
    details;
    constructor(code, message, details) {
        super(message);
        this.name = 'AppError';
        this.code = code;
        this.status = ErrorHttpStatusMap[code] ?? 500;
        this.details = details;
        Object.setPrototypeOf(this, new.target.prototype);
    }
    toEnvelope(requestId) {
        return {
            error: {
                code: this.code,
                message: this.message,
                ...(this.details ? { details: this.details } : {}),
            },
            requestId,
        };
    }
}
//# sourceMappingURL=envelope.js.map